/** Matches backend: min length 2, lowercase start, middle [a-z0-9-_]*, end letter or digit */
export const MODULE_NAME_REGEX = /^[a-z][a-z0-9-_]*[a-z0-9]$/;

/** Matches backend when provider is set (JS `\w` = ASCII letters, digits, underscore) */
export const TERRAFORM_PROVIDER_REGEX = /^\w+$/;
